/**
 * Created by claudenbach on 2/10/2017.
 */

import { AppConstants, LMTimeStampDirective, LMTransformOptions } from '@utils/app.constants';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';

export const lmDateTimeSerializer = (
  lmFormatUtilService: LMFormatUtilService,
  value: string,
  oldValue: string,
  columnDef: ListGridColumn,
  row: number,
  cell: number,
  dataView: any,
  type: string): string => {

  const transformOptions: LMTransformOptions = {};

  if (type === AppConstants.MMDD) {
    return lmFormatUtilService.mmddToData(value);
  } else if (type === AppConstants.YYYY) {
    return lmFormatUtilService.yyyyToData(value);
  } else if (type === AppConstants.YYYYMM) {
    return lmFormatUtilService.yyyymmToData(value);
  } else if (type === AppConstants.YYYYMMDD) {
    return lmFormatUtilService.yyyymmddToData(value);
  } else if (type === AppConstants.TIMESTAMP) {
    if (columnDef.displayField?.timeZoneIs) {
      transformOptions.timeZone = dataView?.fields[columnDef.displayField.timeZoneIs].value as string;
    }
    if (columnDef.displayField?.displayWithTimeZone) {
      transformOptions.displayWithTimeZone = true;
    }
    if (columnDef.displayField?.displayDateAndHoursAndMinutes || columnDef.displayField?.limitToMinuteIncrements) {
      transformOptions.timeStampDirective = LMTimeStampDirective.DISPLAY_DATE_AND_HOURS_AND_MINUTES;
    }
    if (columnDef.displayField?.disableDST) {
      transformOptions.disableDST = true;
    }
    return lmFormatUtilService.timestampToData(value, transformOptions);
  } else if (type === AppConstants.TIME) {
    if (columnDef.displayField?.limitToMinuteIncrements) {
      transformOptions.timeStampDirective = LMTimeStampDirective.DISPLAY_HOURS_AND_MINUTES;
    }
    return lmFormatUtilService.timeToData(value, transformOptions);
  }
};
